import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { css, cx } from '@emotion/css'
import { Badge, BadgeColors } from '@contrast-security-inc/design-system-badges'
import { Priority } from '../api/shared'
import { FormSelect } from '../../../../legacy-design-system/combobox/form-single-select-combobox-object'

interface DefaultPriorityBadgeProps {
  name: string
  color: BadgeColors
  label: string
  priorities?: Priority[]
  inputDataTestId?: string
  disabled?: boolean
}

const priorityRowStyles = css`
  display: flex;
  flex-direction: row;
  gap: 10px;
`

const badgeStyles = css`
  width: 96px;
`

const priorityStyles = css`
  flex-grow: 5;
`

export const DefaultPriorityBadge: FC<DefaultPriorityBadgeProps> = ({
  name,
  color,
  label,
  priorities,
  inputDataTestId,
  disabled
}) => {
  const { formatMessage } = useIntl()
  return (
    <div className={priorityRowStyles}>
      <Badge color={color} className={cx('legacy-ds-badge', badgeStyles)}>
        {formatMessage({ id: label })}
      </Badge>
      <div className={priorityStyles}>
        <FormSelect
          name={name}
          items={[
            {
              items: priorities
                ? priorities.map((priority) => priority.name)
                : []
            }
          ]}
          inputDataTestId={inputDataTestId}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
